const ACTIVATION_KEY_PROPERTY_KEYS = [
  'activation_key_model',
  'activation_key_serial',
  'activation_key_image',
];

export function isActivationKeyLineItem(item) {
  return ACTIVATION_KEY_PROPERTY_KEYS.some((key) => item?.properties?.[key]);
}

export function willMixActivationKeyCart(cartItems, isAddingActivationKey) {
  return (cartItems || []).some(
    (item) => isActivationKeyLineItem(item) !== isAddingActivationKey
  );
}
